import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Button, Card, Typography, Spin, Space } from 'antd';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { ApiService } from '../services/api';
import './SolutionsDetailPage.css';

const { Title } = Typography;

const SolutionsDetailPage = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [solutionDetail, setSolutionDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // 获取解决方案详情
  useEffect(() => {
    const fetchSolutionDetail = async () => {
      if (!id) {
        navigate('/solutions');
        return;
      }

      try {
        setLoading(true);
        setError(null);
        
        const response = await ApiService.getSolutionDetail(id);
        
        if (response.code === '0000' && response.data) {
          setSolutionDetail(response.data);
        } else {
          setError('获取解决方案详情失败');
        }
      } catch (err) {
        console.error('获取解决方案详情失败:', err);
        setError('网络请求失败');
      } finally {
        setLoading(false);
      }
    };

    fetchSolutionDetail();
  }, [id, navigate]);

  const handleBack = () => {
    navigate(-1);
  };

  if (loading) {
    return (
      <div className="solutions-detail-page">
        <div className="container">
          <div className="back-button">
            <Button 
              icon={<ArrowLeftOutlined />} 
              onClick={handleBack}
              size="large"
            >
              返回
            </Button>
          </div>
          <div className="loading-container">
            <Spin size="large" />
            <p>加载解决方案详情中...</p>
          </div>
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="solutions-detail-page">
        <div className="container">
          <div className="back-button">
            <Button 
              icon={<ArrowLeftOutlined />} 
              onClick={handleBack}
              size="large"
            >
              返回
            </Button>
          </div>
          <div className="error-container">
            <p>{error}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!solutionDetail) {
    return (
      <div className="solutions-detail-page">
        <div className="container">
          <div className="back-button">
            <Button 
              icon={<ArrowLeftOutlined />} 
              onClick={handleBack}
              size="large"
            >
              返回
            </Button>
          </div>
          <div className="no-content">
            <p>解决方案内容不存在</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="solutions-detail-page">
      <div className="container">
        {/* 返回按钮 */}
        <div className="back-button">
          <Button 
            icon={<ArrowLeftOutlined />} 
            onClick={handleBack}
            size="large"
          >
            返回
          </Button>
        </div>

        {/* 解决方案详情内容 */}
        <Card className="solutions-detail-card">
          <Space direction="vertical" size="large" style={{ width: '100%' }}>
            {/* 解决方案标题 */}
            <div>
              <Title level={1} className="solutions-detail-title">
                {solutionDetail.solutionTitle}
              </Title>
              <div className="solutions-detail-meta">
                <span className="solutions-date">
                  {solutionDetail.createDate ? new Date(solutionDetail.createDate).toLocaleString('zh-CN', {
                    year: 'numeric',
                    month: '2-digit',
                    day: '2-digit',
                    hour: '2-digit',
                    minute: '2-digit',
                    second: '2-digit'
                  }) : ''}
                </span>
              </div>
            </div>

            {/* 解决方案配图 */}
            {solutionDetail.picUrl && (
              <div className="solutions-detail-image">
                <img 
                  src={solutionDetail.picUrl} 
                  alt={solutionDetail.solutionTitle}
                  className="solutions-main-image"
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            )}

            {/* 解决方案富文本内容 */}
            {solutionDetail.solutionItemContentBind && (
              <div className="solutions-detail-content">
                <div 
                  className="solutions-rich-content"
                  dangerouslySetInnerHTML={{ __html: solutionDetail.solutionItemContentBind }}
                />
              </div>
            )}

          </Space>
        </Card>
      </div>
    </div>
  );
};

export default SolutionsDetailPage;
